import { gql } from 'apollo-angular';

export const ACCOUNT_PROFILE_FRAGMENT = gql`
  fragment AccountProfileFragment on Account {
    id
    authId
    username
    accountType
    manufacturer
    profile {
      salutation
      firstName
      lastName
      position
      phone
      fax
      mobile
      viewSettings
      columnsVisibility
      disablePriceCalculation
    }
    accountRoles {
      organizationRole
      branchRoles {
        branchId
        role
      }
    }
    organization
  }
`;
